/*
 * Take a list of dates with scheduling slot count
 * and return next two open dates with count
 */
export const formatAvailability = (availability, timeZone) => {
  let days = []
  const weekday = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]

  const changeTimezone = (date, ianatz) => {
    const invdate = new Date(
      date.toLocaleString('en-US', {
        timeZone: ianatz,
      })
    )
    const diff = date.getTime() - invdate.getTime()

    return new Date(date.getTime() - diff)
  }

  // format today's date as YYYY-MM-DD for comparison
  const formatDate = (daysOffset = 0) => {
    let date = new Date()
    date.setDate(date.getDate() + daysOffset)
    date = changeTimezone(date, timeZone)
    // match leading zero format
    const day = ('0' + date.getDate()).slice(-2),
      month = ('0' + (date.getMonth() + 1)).slice(-2),
      year = date.getFullYear()
    return `${year}-${month}-${day}`
  }

  const todayFormatted = formatDate(),
    tomorrowFormatted = formatDate(1),
    yesterdayFormatted = formatDate(-1)

  if (availability) {
    // exclude today or yesterday from consideration
    const availabilityStartingTomorrow =
      availability &&
      availability.filter(a => {
        return a.Date !== todayFormatted && a.Date !== yesterdayFormatted
      })

    // format into user friendly date and count
    days = availabilityStartingTomorrow.slice(0, 2).map(a => {
      const month = a.Date.split('-')[1],
        day = a.Date.split('-')[2].split('T')[0],
        year = a.Date.split('-')[0],
        thisDate = new Date(`${month}-${day}-${year}`),
        friendlyDate = `${
          weekday[thisDate.getDay()]
        } ${thisDate.getMonth() + 1}/${thisDate.getDate()}`

      return {
        dateLabel: a.Date === tomorrowFormatted ? 'Tomorrow' : friendlyDate,
        count: a.Count,
      }
    })
  }

  return days
}

/*
 * Take a list of available timeslots
 * and return available dates with count
 */
export const formatSlotsToDays = slots => {
  const datetimes = JSON.parse(slots)
  const availability = []

  const groups = datetimes.reduce((groups, datetime) => {
    const date = datetime.split('T')[0]
    if (!groups[date]) {
      groups[date] = []
    }
    groups[date].push(datetime)
    return groups
  }, {})

  for (const [key, value] of Object.entries(groups)) {
    availability.push({
      date: key,
      count: value.length,
    })
  }

  return availability
}
